__webpack_require__.p = "/ncviewtamale/";